import React, { Component } from 'react';
import NewsArticle from '../../../../src/models/NewsArticle';

type NewsWidgetBlockProps = {
    importantUpdateText: string,
    article: NewsArticle,
}

type NewsWidgetBlockState = {
}

export default class NewsWidgetBlock extends Component<NewsWidgetBlockProps, NewsWidgetBlockState> {
    constructor(props: NewsWidgetBlockProps) {
        super(props);
        this.state = {};
    }

    public async componentDidMount() {
    }

    public render() {
        return (
          <>
            {
                <a className="btn card py-2 px-3 mb-1 mb-md-0 ml-md-4 text-left d-flex flex-row important-news-card" href={this.props.article.url} title={this.props.article.linkText}>
                    <div className="flex-grow-1">
                        <p className="text-overline small text-red font-weight-bolder mb-1">{this.props.importantUpdateText} {this.props.article.publicationDate}</p>
                        <p className="fontweight-bold mb-0 text-line-height-small">{this.props.article.title}</p>
                        <a className="d-none d-md-block pt-1 mt-2 link-chevron" href={this.props.article.url}>{this.props.article.linkText}</a>
                    </div>
                    <div className="d-flex d-md-none align-items-center">
                        <img className="ml-4 mr-2" src="/img/svg/icon-chevron-right.svg" alt=""/>
                    </div>
                </a>
            }
          </>
        );
      }
}